/** A year's amount from one kind of contributor, as the api reports it. */
type Source = { attributes: { kind: string; amount: string } }

/** What one kind of contributor put in over the year, or null where it put in nothing. */
export function contributionAmount(sources: Source[], kind: string): string | null {
  return sources.find((source) => source.attributes.kind === kind)?.attributes.amount ?? null
}

/** Everything put in over the year, by every kind of contributor. */
export function contributionTotal(sources: Source[]): number {
  return sources.reduce((sum, source) => sum + Number(source.attributes.amount), 0)
}
